export default function({ $auth, redirect }) {
    if($auth.user) {
        if($auth.user.attributes['phone-number-verified-at'] === null || $auth.user.attributes['email-verified-at'] === null || $auth.user.attributes['phone-number'] === null) {
            return redirect('/cannot-create-lot')
        }
    } else {
        // console.log("not logged in");
    }
}